import { piersUrl } from 'hatchEndpoints';

    function createInputs( token ) {
        return {
            method: 'GET',
            headers: {
                'content-type': 'application/json',
                'authorization': `Bearer ${ token }`,
            }
        };
    }
    export async function getProfile( personId, token ) {
        const response = await fetch( `${ piersUrl }/profile/${ personId }`, createInputs( token ) );

        return await response.json();
    }
    export async function getMarketPlace( personId, token ) {
        const response = await fetch( `${ piersUrl }/marketplace/${ personId }`, createInputs( token ) );

        return await response.json();
    }
    export async function getCompanies( personId, token ) {
        const response = await fetch( `${ piersUrl }/companies/${ personId }`, createInputs( token ) );

        return await response.json();
    }
    export async function getSolutions( personId, token ) {
        const response = await fetch( `${ piersUrl }/solutions/${ personId }`, createInputs( token ) );

        return await response.json();
      }
    export async function getRewards( personId, token ) {
        const response = await fetch( `${ piersUrl }/rewards/${ personId }`, createInputs( token ) );

        return await response.json();
      }